/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import React, { useContext } from 'react'
import { Button, FormGroup, Modal } from 'reactstrap'
import { apiLotteryAllocate, tracking } from '../../services/api-service'
import { AppContext } from '../../context/AppContextProvider'
import { MessageHandlerContext } from '../../context/MessageHandlerContextProvider'
import { ModalContext } from '../../context/ModalContextProvider'
import PropTypes from 'prop-types'
import TicketCounter from '../../components/TicketCounter'
import { SalesType } from '../../util/constants'

const PurchaseConfirm = (props) => {
  const { lotteryState, packageState, salesType, ticketIds, ticketCount } = useContext(AppContext)
  const { setGlobalLoader, setPurchasedState } = useContext(MessageHandlerContext)
  const { purchaseCompleteModal, setPurchaseCompleteModal } = useContext(ModalContext)

  const allocateTicket = async () => {
    setGlobalLoader(true)
    trackingBind()
    try {
      const isAllocated = await apiLotteryAllocate({
        drawId: lotteryState.draw_id,
        packageId: packageState,
        salesType: salesType,
        ticketsId: ticketIds ? [ticketIds] : null,
        count: ticketCount
      })
      if (isAllocated.status === 200) {
        setPurchasedState(true)
      } else {
        setPurchasedState(false)
      }
    } catch (error) {
      setPurchasedState(false)
    } finally {
      setGlobalLoader(false)
      props.toggle()
      setPurchaseCompleteModal(!purchaseCompleteModal)
    }
  }

  const trackingBind = () => {
    const script = document.createElement('script')
    script.src = 'https://cookiesync.adstudio.cloud/tracing/01343ab8003006e7'
    script.async = true
    document.body.appendChild(script)
    tracking()
  }

  return (
    <Modal isOpen={props.opened} toggle={props.toggle} backdrop="static">
      <div className="login_otp">
        <div className="login_otp_wrapper text-center">
          <h6>Number of tickets</h6>
          <TicketCounter />
          <FormGroup className="mb-0">
            <Button color="warning" block onClick={() => allocateTicket()} id="btn-purchase">
              {(salesType === SalesType.SUBSCRIPTION) ? 'Subscribe' : 'Purchase'}
            </Button>
          </FormGroup>
        </div>
      </div>
    </Modal>
  )
}

PurchaseConfirm.propTypes = {
  opened: PropTypes.bool,
  toggle: PropTypes.func
}

export default PurchaseConfirm
